"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultClientHeader = exports.WebMetadata = exports.Region = exports.AppStartupType = exports.AndroidAppVariant = exports.SpectrumOperatingSystem = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Operating system or environment from which the events were logged. */
var SpectrumOperatingSystem;
(function (SpectrumOperatingSystem) {
    /** OS_UNSET - Unset */
    SpectrumOperatingSystem[SpectrumOperatingSystem["OS_UNSET"] = 0] = "OS_UNSET";
    /** IOS - iOS */
    SpectrumOperatingSystem[SpectrumOperatingSystem["IOS"] = 1] = "IOS";
    /** ANDROID - Android */
    SpectrumOperatingSystem[SpectrumOperatingSystem["ANDROID"] = 2] = "ANDROID";
    /** WEB - Web */
    SpectrumOperatingSystem[SpectrumOperatingSystem["WEB"] = 3] = "WEB";
    SpectrumOperatingSystem[SpectrumOperatingSystem["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SpectrumOperatingSystem = exports.SpectrumOperatingSystem || (exports.SpectrumOperatingSystem = {}));
/** Variant of the Android app in use. Currently not used in iOS. */
var AndroidAppVariant;
(function (AndroidAppVariant) {
    /** APP_VARIANT_UNSET - Unset */
    AndroidAppVariant[AndroidAppVariant["APP_VARIANT_UNSET"] = 0] = "APP_VARIANT_UNSET";
    /** MUSHROOM - Mushroom */
    AndroidAppVariant[AndroidAppVariant["MUSHROOM"] = 1] = "MUSHROOM";
    /** HMS - Huawei Mobile Services, see https://docs.google.com/document/d/11bdjtI1IJyo5RdxMk_BigE_3AedqLHY7YHMIJd5AtEw */
    AndroidAppVariant[AndroidAppVariant["HMS"] = 2] = "HMS";
    AndroidAppVariant[AndroidAppVariant["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AndroidAppVariant = exports.AndroidAppVariant || (exports.AndroidAppVariant = {}));
/** Distinguishes between Cold vs. Warm app startup types. */
var AppStartupType;
(function (AppStartupType) {
    /** STARTUP_TYPE_UNSET - Unset */
    AppStartupType[AppStartupType["STARTUP_TYPE_UNSET"] = 0] = "STARTUP_TYPE_UNSET";
    /** COLD - Cold */
    AppStartupType[AppStartupType["COLD"] = 1] = "COLD";
    /** WARM - Warm */
    AppStartupType[AppStartupType["WARM"] = 2] = "WARM";
    AppStartupType[AppStartupType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AppStartupType = exports.AppStartupType || (exports.AppStartupType = {}));
/** Google Cloud Region */
var Region;
(function (Region) {
    /** REGION_UNSET - unset */
    Region[Region["REGION_UNSET"] = 0] = "REGION_UNSET";
    /** REGION_US_CENTRAL_1 - us-central1 */
    Region[Region["REGION_US_CENTRAL_1"] = 1] = "REGION_US_CENTRAL_1";
    /** REGION_EUROPE_WEST_1 - europe-west1 */
    Region[Region["REGION_EUROPE_WEST_1"] = 2] = "REGION_EUROPE_WEST_1";
    /** REGION_ASIA_SOUTHEAST_1 - asia-southeast1 */
    Region[Region["REGION_ASIA_SOUTHEAST_1"] = 3] = "REGION_ASIA_SOUTHEAST_1";
    Region[Region["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Region = exports.Region || (exports.Region = {}));
function createBaseWebMetadata() {
    return { browser: "", browserVersion: "", domain: "", referrer: "" };
}
exports.WebMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.browser !== "") {
            writer.uint32(10).string(message.browser);
        }
        if (message.browserVersion !== "") {
            writer.uint32(18).string(message.browserVersion);
        }
        if (message.domain !== "") {
            writer.uint32(26).string(message.domain);
        }
        if (message.referrer !== "") {
            writer.uint32(34).string(message.referrer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWebMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.browser = reader.string();
                    break;
                case 2:
                    message.browserVersion = reader.string();
                    break;
                case 3:
                    message.domain = reader.string();
                    break;
                case 4:
                    message.referrer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseWebMetadata();
        message.browser = object.browser ?? "";
        message.browserVersion = object.browserVersion ?? "";
        message.domain = object.domain ?? "";
        message.referrer = object.referrer ?? "";
        return message;
    },
};
function createBaseDefaultClientHeader() {
    return {
        sessionId: "",
        userGuid: "",
        appBuild: "",
        appVersion: "",
        osVersion: "",
        osType: 0,
        clientId: "",
        locale: "",
        deviceModel: "",
        accountAgeDays: 0,
        appStartupType: 0,
        androidAppVariant: 0,
        instalogDoubleLogged: false,
        queueName: "",
        region: 0,
        webMetadata: undefined,
    };
}
exports.DefaultClientHeader = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sessionId !== "") {
            writer.uint32(10).string(message.sessionId);
        }
        if (message.userGuid !== "") {
            writer.uint32(18).string(message.userGuid);
        }
        if (message.appBuild !== "") {
            writer.uint32(26).string(message.appBuild);
        }
        if (message.appVersion !== "") {
            writer.uint32(34).string(message.appVersion);
        }
        if (message.osVersion !== "") {
            writer.uint32(42).string(message.osVersion);
        }
        if (message.osType !== 0) {
            writer.uint32(48).int32(message.osType);
        }
        if (message.clientId !== "") {
            writer.uint32(58).string(message.clientId);
        }
        if (message.locale !== "") {
            writer.uint32(66).string(message.locale);
        }
        if (message.deviceModel !== "") {
            writer.uint32(74).string(message.deviceModel);
        }
        if (message.accountAgeDays !== 0) {
            writer.uint32(80).int32(message.accountAgeDays);
        }
        if (message.appStartupType !== 0) {
            writer.uint32(88).int32(message.appStartupType);
        }
        if (message.androidAppVariant !== 0) {
            writer.uint32(96).int32(message.androidAppVariant);
        }
        if (message.instalogDoubleLogged === true) {
            writer.uint32(104).bool(message.instalogDoubleLogged);
        }
        if (message.queueName !== "") {
            writer.uint32(114).string(message.queueName);
        }
        if (message.region !== 0) {
            writer.uint32(120).int32(message.region);
        }
        if (message.webMetadata !== undefined) {
            exports.WebMetadata.encode(message.webMetadata, writer.uint32(130).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDefaultClientHeader();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sessionId = reader.string();
                    break;
                case 2:
                    message.userGuid = reader.string();
                    break;
                case 3:
                    message.appBuild = reader.string();
                    break;
                case 4:
                    message.appVersion = reader.string();
                    break;
                case 5:
                    message.osVersion = reader.string();
                    break;
                case 6:
                    message.osType = reader.int32();
                    break;
                case 7:
                    message.clientId = reader.string();
                    break;
                case 8:
                    message.locale = reader.string();
                    break;
                case 9:
                    message.deviceModel = reader.string();
                    break;
                case 10:
                    message.accountAgeDays = reader.int32();
                    break;
                case 11:
                    message.appStartupType = reader.int32();
                    break;
                case 12:
                    message.androidAppVariant = reader.int32();
                    break;
                case 13:
                    message.instalogDoubleLogged = reader.bool();
                    break;
                case 14:
                    message.queueName = reader.string();
                    break;
                case 15:
                    message.region = reader.int32();
                    break;
                case 16:
                    message.webMetadata = exports.WebMetadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDefaultClientHeader();
        message.sessionId = object.sessionId ?? "";
        message.userGuid = object.userGuid ?? "";
        message.appBuild = object.appBuild ?? "";
        message.appVersion = object.appVersion ?? "";
        message.osVersion = object.osVersion ?? "";
        message.osType = object.osType ?? 0;
        message.clientId = object.clientId ?? "";
        message.locale = object.locale ?? "";
        message.deviceModel = object.deviceModel ?? "";
        message.accountAgeDays = object.accountAgeDays ?? 0;
        message.appStartupType = object.appStartupType ?? 0;
        message.androidAppVariant = object.androidAppVariant ?? 0;
        message.instalogDoubleLogged = object.instalogDoubleLogged ?? false;
        message.queueName = object.queueName ?? "";
        message.region = object.region ?? 0;
        message.webMetadata =
            object.webMetadata !== undefined && object.webMetadata !== null
                ? exports.WebMetadata.fromPartial(object.webMetadata)
                : undefined;
        return message;
    },
};
//# sourceMappingURL=common_client_header.js.map